export default {
  getDevices: {
    server: '/corporations/{corporationId}/devices',
    method: 'get',
  },
  getDeviceTasks: {
    server: '/corporations/{corporationId}/devices/{device}/tasks',
    method: 'get',
  },
  delDeviceTasks: {
    server: '/corporations/{corporationId}/devices/{device}/tasks/{id}',
    method: 'delete',
  },
  addDevice: {
    server: '/corporations/{corporationId}/devices',
    method: 'post',
  },
  putDevice: {
    server: '/corporations/{corporationId}/devices/{deviceId}',
    method: 'put',
  },
  patchDeviceConfig: {
    server: '/corporations/{corporationId}/devices/{deviceId}/config',
    method: 'patch',
  },
  deleteDevice: {
    server: '/corporations/{corporationId}/devices/{deviceId}',
    method: 'delete',
  },
  getDeviceTypeOptions: {
    server: '/constants/device-type-options',
    method: 'get',
  },
  getCollectorTypeOptions: {
    server: '/constants/collector-type-options',
    method: 'get',
  },
  getCollectorProtocolOptions: {
    server: '/constants/collector-protocol-options/{type}',
    method: 'get',
  },
  GetGnssBaseStationDevicesOptions: {
    server: '/projects/{projectId}/devices/gnss-base-station/structures/{structureId}',
    method: 'get',
  },
  getCategoryOptions: {
    server: '/constants/category-options',
    method: 'get',
  },
  getDeviceCategoryOptions: {
    server: '/constants/device-category-options/{measurement}',
    method: 'get',
  },
  statDevice: {
    server: '/corporations/{corporationId}/devices/stat',
    method: 'get',
  },
  setInit: {
    server: '/corporations/{corporationId}/devices/{deviceId}/init',
    method: 'patch',
  },
  patchDeviceChannelConfig: {
    server: '/corporations/{corporationId}/devices/{deviceId}/channel-config',
    method: 'patch',
  },
  patchDeviceProcessorConfig: {
    server: '/corporations/{corporationId}/devices/{deviceId}/processor-config',
    method: 'patch',
  },
  patchDeviceChartConfig: {
    server: '/corporations/{corporationId}/devices/{deviceId}/chart-config',
    method: 'patch',
  },
  getSystemFormualOptions: {
    server: '/constants/system-formula',
    method: 'get',
  },
  patchHealthThreshold: {
    server: '/corporations/{corporationId}/devices/{deviceId}/health-threshold',
    method: 'patch',
  },
  bulkCreate: {
    server: '/corporations/{corporationId}/devices/bulk-create',
    method: 'post',
  },
  getNewPort: {
    server: '/constants/gnss-port',
    method: 'get',
  },
};
